module.exports = __webpack_public_path__ + "static/media/logo.00cb3c9f.png";